/*
 * Names of Maestro employers, as every screen shows them. Kept apart from
 * recruiter-role.store (which re-exports them) so a screen that only needs a
 * name does not pull in that store's whole import graph.
 */
export const createFullName = (firstName, lastName) => {
	const first = firstName || ''
	const last = lastName || ''
	return [first, last].filter(Boolean).join(' ').trim() || 'Unknown User'
}

// recruiterProfile and list rows do not always share the same field shape — the
// collision path in particular can arrive with full_name only. Normalize once so
// every dialog reads the same firstName / lastName / fullName triple.
export const normalizeEmployerPopupData = (employer) => {
	if (!employer) return employer

	const firstName = employer.firstName ?? employer.first_name ?? ''
	const lastName = employer.lastName ?? employer.last_name ?? ''
	const fullName = employer.fullName || employer.full_name || createFullName(firstName, lastName)

	return { ...employer, firstName, lastName, fullName }
}

// Clone each relation so Formik / Autocomplete cannot mutate the store row the
// detail screen is still rendering from the same array reference.
export const normalizeEmployerRelations = (employers = []) => (employers || []).map((employer) => normalizeEmployerPopupData({ ...employer }))
